import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  signal,
} from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { BackgroundAnimationComponent } from '@app/components/background-animation';

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet, RouterLink, BackgroundAnimationComponent],
  templateUrl: './auth-layout.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``,
})
export class AuthLayout {
  private readonly destroyRef = inject(DestroyRef);
  protected readonly isNavbarScrolled = signal(false);

  constructor() {
    afterNextRender(() => {
      this.updateNavbarScrolled();
      window.addEventListener('scroll', this.updateNavbarScrolled, { passive: true });
      document.addEventListener('scroll', this.updateNavbarScrolled, {
        capture: true,
        passive: true,
      });
      this.destroyRef.onDestroy(() => {
        window.removeEventListener('scroll', this.updateNavbarScrolled);
        document.removeEventListener('scroll', this.updateNavbarScrolled, true);
      });
    });
  }

  private readonly updateNavbarScrolled = (event?: Event): void => {
    const targetScrollTop = event?.target instanceof HTMLElement ? event.target.scrollTop : 0;
    const scrollTop = Math.max(
      window.scrollY,
      document.documentElement.scrollTop,
      document.body.scrollTop,
      targetScrollTop,
    );

    this.isNavbarScrolled.set(scrollTop > 8);
  };
}
